<template>
  <div class="Share" :class="{'bingo': bingo}">

    <input v-model="shareStr" ref="input" @click="copyUrl($event.target)" readonly/>

  </div>
</template>

<script>

import { store } from '@/store';

export default {
  name: 'Landing',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    bingo: function () {
      return store.state.bingo;
    },
    shareStr: function () {
      return "https://resebingo.se/?b=" + store.state.shareStr;
    }
  },
  watch: {
  },
  methods: {
    copyUrl: function (target) {
      target.focus();
      target.select();
      target.setSelectionRange(0, 999);
      document.execCommand("copy");
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.Share{
  background: lightblue;
  width: 100%;
  max-width: 600px;
  padding: 5px;
  text-align: center;
  transition: background 0.25s;
}

.Share:not(:focus-within)::before{
  content: "Dela din bricka!";
}

.Share:focus-within{
  background: lightgreen;
}

.Share:focus-within::before{
   content: "Webbadress kopierad!";

}

input{
  display: block;
  width: 100%;
  text-align: center;
  border: 0;
  outline: none;
  cursor: copy;
  font-size: 1em;
  padding: 3px;
  box-sizing: border-box;
}

@keyframes party {
  50% {
    background: lightblue;
  }
}

.bingo {
  background: palegreen;
  animation: party 1.5s infinite;
}

</style>



// WEBPACK FOOTER //
// src/components/Share.vue